import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";
import { Service } from "./Service";

const endpoint = "Penalty";

/** Penalty shootout kicks. Record/UndoLast broadcast to the club's boards. */
export const PenaltyService = {
	endpoint,
	getByFixture: async (fixtureId: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetByFixture/${fixtureId}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	record: async (data: {fixtureId: number, teamId: number, shotOrder: number, scored: boolean}) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Record`, {body: JSON.stringify(data), headers: {"Content-Type": "application/json"}, method: "POST"}),
	undoLast: async (fixtureId: number) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/UndoLast/${fixtureId}`, {headers: {"Content-Type": "application/json"}, method: "DELETE"}),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id)
}
